/**
 * Poseedores API
 * Poseedores API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PlataformaOrigenDTO } from './plataformaOrigenDTO';
import { PoseedorDTO } from './poseedorDTO';
import { CodigoLerDTO } from './codigoLerDTO';
import { AportacionDIEstadoDTO } from './aportacionDIEstadoDTO';
import { OperacionGestionDTO } from './operacionGestionDTO';
import { FacturaRecordDTO } from './facturaRecordDTO';
import { GestoresResiduosDTO } from './gestoresResiduosDTO';
import { DescripcionEnvaseDTO } from './descripcionEnvaseDTO';
import { DocumentoDTO } from './documentoDTO';


export interface AportacionDIPoseedorDTO { 
    fechaAlta?: string;
    creadoPor?: string;
    fechaModificacion?: string;
    modificadoPor?: string;
    id?: number;
    nimaGestor?: string;
    estado?: AportacionDIEstadoDTO;
    documentoIdentificacion?: string;
    fechaRecogida?: string;
    fechaAceptacion?: string;
    fechaAportacion?: string;
    documento?: DocumentoDTO;
    factura?: FacturaRecordDTO;
    gestorResiduo?: GestoresResiduosDTO;
    codigoLer?: CodigoLerDTO;
    poseedor?: PoseedorDTO;
    descripcionEnvase?: DescripcionEnvaseDTO;
    operacionGestion?: OperacionGestionDTO;
    cantidadGestionada?: number;
    motivoRechazo?: string;
    origen?: AportacionDIPoseedorDTO.OrigenEnum;
    esCreadoPoseedor?: boolean;
    documentoIdentificacionUipath?: string;
    fechaAceptacionUipath?: string;
    nimaPoseedorUipath?: string;
    poseedorReferenceUipath?: PoseedorDTO;
    nimaGestorUipath?: string;
    gestorResiduoReferenceUipath?: GestoresResiduosDTO;
    codigoLerReferenceUipath?: CodigoLerDTO;
    codigoLerUipath?: string;
    descripcionCodigoLerUipath?: string;
    operacionGestionReferenceUipath?: OperacionGestionDTO;
    codigoOperacionUipath?: string;
    descripcionOperacionUipath?: string;
    cantidadGestionadaUipath?: number;
    externa?: boolean;
    esAportacionSDDRCA?: boolean;
    plataformaOrigen?: PlataformaOrigenDTO;
}
export namespace AportacionDIPoseedorDTO {
    export type OrigenEnum = 'SDDRCC' | 'POSEEDOR' | 'SDDRCA' | 'GESTORESACUERDO';
    export const OrigenEnum = {
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Poseedor: 'POSEEDOR' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum
    };
}


